<dxc-modal
  [dxcContainerClass]="
    eligibityCheckStep === 1 ? 'eligibility-check-modal full-modal' : 'eligibility-check-modal'
  "
  [dxcBodyContent]="modalContent"
  [dxcModalWidth]="'90%'"
  [(dxcVisible)]="eligibilityModalVisible"
  [dxcPrimaryBtnText]="
    eligibityCheckStep === 2
      ? !isEmbedded || allowedPages.dailyHuddle
        ? 'GO BACK TO HUDDLE'
        : 'CLOSE'
      : ''
  "
  dxcFooterCentered
  (dxcOnClose)="onEligibilityModalClose()"
  (dxcOnPrimaryBtnClick)="rediectToDailyHuddle()"
>
</dxc-modal>

<ng-template #modalContent>
  <div *ngIf="eligibityCheckStep === 1">
    <h5 dxc-typography dxcSize="xl" dxcWeight="semibold">
      {{
        eligibilityForm.value['formType'] === 'EDIT'
          ? 'EDIT APPOINTMENT INFORMATION'
          : 'NEW ELIGIBILITY CHECK'
      }}
      <dxc-icon
        *ngIf="!isEmbedded || allowedPages.informationIcon"
        class="cursor-pointer"
        (click)="showEligCheckHelpModal()"
        [dxcIcon]="['far', 'circle-info']"
        dxcSize="sm"
      />
    </h5>
    <p dxc-typography *ngIf="eligibilityForm.value['formType'] !== 'EDIT'">
      Please provide the following information to run an eligibility check
    </p>
    <app-new-eligibility-form
      [submitLoading]="submitLoading"
      [eligform]="eligibilityForm"
      [providers]="providers"
      [payers]="payers"
      [procedurescode]="procedurescode"
      [isEditAppointment]="eligibilityForm.value['formType'] === 'EDIT'"
      [tags]="tags"
      (onSubmit)="onEligibilityFormSubmit()"
      (onSubscriberSameAsPatient)="onEligibilitySubscriberSameAsPatient()"
      (onProviderSelect)="setProviderDetails($event)"
      (onClearForm)="onClearEligibilityForm()"
    />
  </div>

  <div *ngIf="eligibityCheckStep === 2" class="text-center my-4">
    <h1 dxc-typography dxcSize="xl" dxcWeight="semibold">Appointment saved successfully</h1>
    <p dxc-typography class="mt-3">
      We are processing the eligibility check, its gonna take sometime.
    </p>
  </div>
</ng-template>
